export const getAnnouncementVideoEmbedUrl = (url?: string | null): string | null => {
    if (!url) {
        return null;
    }

    try {
        const parsed = new URL(url);

        if (parsed.hostname.includes("youtube.com")) {
            const videoId = parsed.searchParams.get("v");
            return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
        }

        if (parsed.hostname === "youtu.be") {
            const videoId = parsed.pathname.slice(1);
            return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
        }

        if (parsed.hostname.includes("vimeo.com")) {
            const videoId = parsed.pathname.split("/").pop();
            if (videoId && /^\d+$/.test(videoId)) {
                return `https://player.vimeo.com/video/${videoId}`;
            }
        }

        return null;
    } catch {
        return null;
    }
};
